import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const IAA = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Incubation of aptamers with AuNPs: This incubation is done to bind the primary aptamer with the modification in the extreme 3’ with the thiol group to the AuNPs. This protocol was done in collaboration with the team iGEM TecCEM, as they have a nanotechnology lab that could perform this protocol.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/9.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 8. Diagram of aptamers binding to AuNPs. Created<br/>with BioRender.com</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default IAA;
